import React from "react";
import Box from "@mui/material/Box";
import { TextField, Grid } from "@mui/material";

type Props = {
  formik: any;
  disabled?: boolean;
  children?: React.ReactNode;
};

const PricingStep = ({ formik, disabled = false, children }: Props) => {
  const { values, touched, errors, handleChange, handleBlur } = formik;

  return (
    <Box sx={{ maxWidth: 720 }}>
      <Grid container spacing={2} sx={{ mb: 1 }}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Price (Rs)"
            name="price"
            type="number"
            value={values.price}
            onBlur={handleBlur}
            onChange={handleChange}
            error={touched.price && Boolean(errors.price)}
            helperText={touched.price && errors.price}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Old Price (Rs)"
            name="old_price"
            type="number"
            value={values.old_price}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Special / Sale Price (Rs)"
            name="special_price"
            type="number"
            value={values.special_price}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            disabled={disabled}
            label="Discount (%)"
            name="discount_in_percent"
            type="number"
            value={values.discount_in_percent}
            onBlur={handleBlur}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      {children}
    </Box>
  );
};

export default PricingStep;
